import * as yup from 'yup';

yup.addMethod(yup.string, 'numbers', function () {
  return this.test('integer', function () {
    const { createError } = this;
    const fieldsNumberDevice = document.getElementsByClassName('input-number');
    const promises = [];
    for (let i = 0; i < fieldsNumberDevice.length; i++) {
      const field = fieldsNumberDevice[i];
      const { value, name } = field;
      const promise = new Promise((resolve, reject) => {
        if (field && /^\d+$/.test(value)) {
          resolve(true);
        } else {
          reject(
            createError({ message: 'Invalid integer number', path: name })
          );
        }
      });
      promises.push(promise);
    }
    return Promise.all(promises);
  });
});

yup.addMethod(yup.string, 'repeat', function () {
  return this.test('repeat', function () {
    const { createError } = this;
    const fieldsNumberDevice = document.getElementsByClassName('input-number');
    const promises = [];
    const fieldValues = [];
    for (let i = 0; i < fieldsNumberDevice.length; i++) {
      const field = fieldsNumberDevice[i];
      const { value } = field;
      fieldValues.push(value);
    }
    for (let i = 0; i < fieldsNumberDevice.length; i++) {
      const field = fieldsNumberDevice[i];
      const { value, name } = field;
      const promise = new Promise((resolve, reject) => {
        const filters = fieldValues.filter(fieldValue => fieldValue === value);
        if (field && !(filters.length > 1)) {
          resolve(true);
        } else {
          reject(createError({ message: 'Value repeated', path: name }));
        }
      });
      promises.push(promise);
    }
    return Promise.all(promises);
  });
});

yup.addMethod(yup.string, 'start', function () {
  return this.test('start', function () {
    const { path, createError } = this;
    const startField = document.getElementsByName(path)[0];
    const endField = document.getElementsByName('final')[0];
    return new Promise((resolve, reject) => {
      if (
        startField &&
        endField &&
        parseInt(startField.value, 10) <= parseInt(endField.value, 10)
      ) {
        resolve(true);
      } else {
        reject(createError({ path, message: 'start smaller than the end' }));
      }
    });
  });
});

const schema = yup.object().shape({
  type: yup
    .string()
    .required()
    .trim(),
  name: yup.string().when('type', {
    is: value => value === 'G' || value === 'E' || value === 'L',
    then: yup
      .string()
      .required()
      .trim()
  }),
  initials: yup.string().when('type', {
    is: value => value === 'G',
    then: yup
      .string()
      .required()
      .trim()
      .max(5)
  }),
  department: yup
    .string()
    .required()
    .trim(),
  pabx: yup
    .string()
    .required()
    .trim(),
  // range
  number: yup
    .string()
    .when('typeRegister', {
      // add device
      is: 'R',
      then: yup
        .string()
        .repeat()
        .numbers()
    })
    .when('typeRegister', {
      // edit device
      is: value => !value,
      then: yup.string().numbers()
    }),
  // interval
  initial: yup.string().when('typeRegister', {
    is: 'I',
    then: yup
      .string()
      .start()
      .required()
      .trim()
  }),
  // interval
  final: yup.string().when('typeRegister', {
    is: 'I',
    then: yup
      .string()
      .required()
      .trim()
  })
});

export default schema;
